import { api } from '../../lib/api';
import type { SessionStatus } from './webauthn';

/**
 * الدخول اليومي كله هنا (قرار O-13): `POST /auth/login` بـ `{ username, password }`
 * يفتح جلسة `web_session` ويضع الكوكي — لا رمز ثانٍ ولا شرط passkey. مراسم passkey
 * الاختيارية في `webauthn.ts`. سقف المسار 5 محاولات كل 15 دقيقة لكل IP (قرار D25).
 */

export interface LoginInput {
  readonly username: string;
  readonly password: string;
}

export function login(input: LoginInput): Promise<SessionStatus> {
  return api.post<SessionStatus>('/auth/login', input);
}

/**
 * `passkey_registered` يُقرأ قبل المصادقة: بلا مفتاح مسجَّل لا تعرض شاشة الدخول زر
 * البصمة إطلاقًا — passkey إضافة اختيارية لا تُطلب في أول دخول (قرار O-13).
 */
export interface AuthProbe extends SessionStatus {
  readonly passkey_registered: boolean;
  /**
   * `false` = خادمٌ جديد لم يُشغَّل فيه `owner:set-password` بعد. يُقرأ قبل المصادقة
   * كي تقول الشاشة ذلك **قبل أن يكتب المالك**، فلا تُستهلك محاولة من سقف 5/15 دقيقة
   * على حالةٍ لا تُصلحها إعادة الكتابة (بند N-127).
   */
  readonly password_set: boolean;
}

export function fetchAuthSession(): Promise<AuthProbe> {
  return api.get<AuthProbe>('/auth/session');
}
